import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { Sort, SortDirection } from '@angular/material/sort'
import { ISelectItem } from '@lla-platform/core/core-ui'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-bottom-sheet-sort',
  templateUrl: './bottom-sheet-sort.component.html',
  styleUrls: ['./bottom-sheet-sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BottomSheetSortComponent {
  @Input() sortState?: Sort
  @Input() items: ISelectItem[] = []

  @Output() sortChanged = new EventEmitter<Sort>()

  onSortChanged(info: { column?: string; direction?: SortDirection }) {
    if (!this.sortState) {
      this.sortChanged.emit(undefined)
      return
    }
    this.sortChanged.emit({
      active: info.column ?? this.sortState.active,
      direction: info.direction ?? this.sortState.direction
    })
  }
}
